module.exports = __webpack_public_path__ + "media/luxury-2026/mianus-architecture-93d9de68.jpg";